import Model from './Model'

export default class GuardCodeModel extends Model {
  public id: number|undefined

  resource () : string {
    return 'guardCodes'
  }
}
